"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("../index.scss");
const DisabledTable = () => (react_1.default.createElement("div", { className: "royalties-table" },
    react_1.default.createElement("table", null,
        react_1.default.createElement("tbody", null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("th", { className: "index-white" }, "Payee"),
                react_1.default.createElement("th", { className: "index-white" }, "DSP"),
                react_1.default.createElement("th", { className: "index-white" }, "Distribution Period"),
                react_1.default.createElement("th", { className: "index-white" }, "Use Type"),
                react_1.default.createElement("th", { className: "index-white" }, "Amount"),
                react_1.default.createElement("th", { className: "index-white" }, "Select"))))));
exports.default = DisabledTable;
